import {
  ECatalogItemIdentifierType,
  TDestinationSetting,
} from '@/core/apis/config_api/config_api_types';
import { EDestinationType } from '@/core/interfaces';

export const TEST_DESTINATIONS: TDestinationSetting[] = [
  {
    active: true,
    creds: {
      catalog_item_identifier_type: ECatalogItemIdentifierType.VARIANT_ID,
    },
    id: '0',
    type: EDestinationType.Mable,
  },
  {
    active: true,
    creds: {
      catalog_item_identifier_type: ECatalogItemIdentifierType.VARIANT_ID,
      container_id: 'GTM-W8DVRKT2',
      sgtm_container_url: 'https://gtm-server.dev.mable.ai',
    },
    id: '12',
    type: EDestinationType.WSGTM,
  },
  {
    active: true,
    creds: {
      catalog_item_identifier_type: ECatalogItemIdentifierType.VARIANT_ID,
      measurementId: 'G-BGP6D0TXX7',
    },
    id: '11',
    type: EDestinationType.GA4,
  },
  {
    active: true,
    creds: {
      catalog_item_identifier_type: ECatalogItemIdentifierType.VARIANT_ID,
      pixelId: '1471314667031484',
    },
    id: '5',
    type: EDestinationType.Facebook,
  },
  {
    active: true,
    creds: {
      catalog_item_identifier_type: ECatalogItemIdentifierType.VARIANT_ID,
      containerId: 'GTM-59T8ZBM',
    },
    id: '1',
    type: EDestinationType.GTM,
  },
  {
    active: true,
    creds: {
      adwordsId: 'AW-475399036',
      catalog_item_identifier_type: ECatalogItemIdentifierType.VARIANT_ID,
      conversionEventsMap: {
        add_to_cart: 'b3pICI7X4vUYEPyG2OIB',
      },
      remarketingEventsDisabled: false,
    },
    id: '2',
    type: EDestinationType.GoogleAds,
  },
];
